import { Mutation, MutationTree } from "vuex";
import State from "./state";
import { IMenuModel } from "src/model";

/**
 * 更新accessToken
 * @param state 
 * @param accessToken 
 */
export function SET_ACCESS_TOKEN(state: State, accessToken: string): void
{
    state.accessToken = accessToken;

    if (accessToken)
    {
        localStorage.setItem("accessToken", accessToken);
    }
}

/**
 * 修改用户信息
 * @param state 
 * @param accessToken 
 */
export function SET_USER_INFO(state: State, userInfo: any): void
{
    state.userInfo = userInfo;

    if (userInfo)
    {
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
    }
}

/**
 * 更新refreshtoken
 * @param state 
 * @param accessToken 
 */
export function SET_REFRESH_TOKEN(state: State, refreshtoken: string): void
{
    state.refreshtoken = refreshtoken;

    if (refreshtoken)
    {
        localStorage.setItem("refreshtoken", refreshtoken);
    }
}

/**
 * 更新店铺id
 * @param state 
 * @param accessToken 
 */
export function SET_TENANT_ID(state: State, tenantId: number): void
{
    state.tenantId = tenantId;

    if (tenantId)
    {
        localStorage.setItem("tenantId", tenantId + "");
    }
}

/**
 * 更新菜单数据
 * @param state 
 * @param accessToken 
 */
export function SET_MENU_DATA(state: State, menuData: Array<IMenuModel>): void
{
    state.menuData = menuData;

    if(menuData)
    {
        localStorage.setItem("menuData", JSON.stringify(menuData));
    }
}

/**
 * 控制路由守卫状态值
 * @param state 
 * @param data 
 */
export function SET_IS_LOGIN(state: State, data: number): void
{
    state.isLogin = data;
}

export default <MutationTree<State>>
{
    SET_ACCESS_TOKEN,
    SET_MENU_DATA,
    SET_IS_LOGIN,
    SET_REFRESH_TOKEN,
    SET_TENANT_ID,
    SET_USER_INFO
};
